import script from "./tabelaKoparek.vue?vue&type=script&setup=true&lang=ts"
export * from "./tabelaKoparek.vue?vue&type=script&setup=true&lang=ts"

import "./tabelaKoparek.vue?vue&type=style&index=0&id=c8e44c28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8e44c28"]])

export default __exports__